import { DateTime } from 'luxon';
import { useContext, useState } from 'react';
import { useGetModelPortfoliosMonthlyReturns } from '../../../../api/funds-robot/getModelPortfolioMonthlyReturns';
import { Portfolio } from '../../../../types/Portfolio';
import { buildMonthlyReturnRatesCSVString, downloadCSV } from '../../../../utils/functions';
import { ModalScreenFunds } from '../../../general/ModalScreen';
import { ComparisonScreenFundSelectionContext } from '../ComparisonScreen';
import { MonthlyReturn } from '../nav-overlay-tables/MonthlyReturn';
import { OverlayTableHeader } from '../nav-overlay-tables/OverlayTableHeader';

export const MonthlyReturnsModal: React.FC<{ portfolio: Portfolio; isShown: boolean; onClose: () => void }> = ({
    isShown,
    onClose,
    portfolio,
}) => {
    const [year, setYear] = useState(DateTime.now().year);

    const portfolioReturns = useGetModelPortfoliosMonthlyReturns(
        portfolio?.id,
        DateTime.now().minus({ year: 10 }),
        DateTime.now(),
    );
    const { selectedFund } = useContext(ComparisonScreenFundSelectionContext);

    return (
        <ModalScreenFunds isShown={isShown}>
            <div className="bg-gray-100">
                <OverlayTableHeader
                    title={`Maandelijks rendement -  ${selectedFund?.name}`}
                    onClose={onClose}
                    selectedYear={year}
                    onYearSelected={setYear}
                    onExportCSV={() => {
                        downloadCSV(
                            portfolio.name + ' rendement.csv',
                            buildMonthlyReturnRatesCSVString(portfolioReturns.data?.monthlyReturnRates || []),
                        );
                    }}
                />
                <MonthlyReturn portfolio={portfolio} className="pr-6 pb-6" />
            </div>
        </ModalScreenFunds>
    );
};
